/* eslint-disable import/prefer-default-export */
export const PERIODTYPE = {
  ONCE: 'N',
  DAILY: 'D',
  WEEKLY: 'W',
  MONTHLY: 'M',
};

export const LASTDAY = 'E';



// WEBPACK FOOTER //
// ./src/constants/schedule.js